import * as Icons from "lucide-react";
import { Reveal, SectionHeading } from "./Reveal";
import { LionWatermark } from "./LionWatermark";
import { WHY_US } from "../../data/content";

export const WhyChooseUs = () => {
  return (
    <section
      id="why-us"
      data-testid="why-us-section"
      className="bcg-grain relative overflow-hidden border-t border-[#c9a24d]/25 bg-[#0a0a0a] py-24 lg:py-32"
    >
      <LionWatermark className="-right-16 top-12 h-[420px] sm:h-[520px]" />
      <div className="relative z-10 mx-auto max-w-7xl px-6 lg:px-8">
        <Reveal>
          <SectionHeading
            overline="Why Blacklion"
            title="The difference is in the details."
            sub="We combine the strength of an established Toronto general contractor with the precision and accountability of a boutique firm."
          />
        </Reveal>

        <div className="mt-16 grid gap-8 sm:grid-cols-2 lg:grid-cols-4">
          {WHY_US.map((w, i) => {
            const Icon = Icons[w.icon] || Icons.Award;
            return (
              <Reveal key={w.title} delay={i * 0.4}>
                <div
                  data-testid={`why-card-${i}`}
                  className="group h-full border-l border-white/10 pl-6 transition-colors hover:border-gold"
                >
                  <div className="flex items-center gap-4">
                    <span className="font-display text-4xl font-extrabold text-gold/30 transition-colors group-hover:text-gold/60">
                      {w.num}
                    </span>
                    <Icon size={28} strokeWidth={1.5} className="text-gold" />
                  </div>
                  <h3 className="font-display mt-5 text-lg font-bold text-white">
                    {w.title}
                  </h3>
                  <p className="mt-3 text-sm leading-relaxed text-neutral-400">
                    {w.desc}
                  </p>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};
